import React, { useState } from 'react';
import { Modal, Input, Button, Space, Form, message } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import './PoPopup.module.scss';
import { addPoNumber } from '@/api/newApi/order';

interface PoPopupProps {
  visible: boolean;
  onCancel: () => void;
  orderId: string;
  onConfirm: (id: string) => void;
}

const PoPopup: React.FC<PoPopupProps> = ({ visible, onCancel, orderId, onConfirm }) => {
  const [form] = Form.useForm();
  const [poNumber, setPoNumber] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  
  const handleConfirm = async () => {
    try {
      setSubmitLoading(true);
      // 表单验证
      await form.validateFields();
      const params = {
        orderId: orderId,
        thirdOrderId: poNumber,
      }
      const res = await addPoNumber(params);
      if (res.success) {
        message.success(TLT(`PO单号添加成功`));
        // 返回添加的PO单号
        onConfirm(poNumber);
        onCancel();
      } else {
        message.error(TLT(`添加失败`));
      }
      // 验证通过后调用onConfirm
    } catch (error) {
      // 验证失败，不执行后续操作
      console.error('表单验证失败:', error);
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Modal
      className="po-popup-modal"
      open={visible}
      title={null}
      footer={null}
      onCancel={onCancel}
      width={450}
      centered
      maskClosable={true}
    >
      <div className="po-popup-container">
        <div className="po-popup-header">
          <ExclamationCircleFilled className="warning-icon" />
          <span className="po-popup-title">{TLT(`请添加PO单号`)}</span>
        </div>
        
        <div className="po-popup-content">
          <p className="po-popup-description">{TLT(`添加PO单号后不可再次修改！`)}</p>
          
          <Form form={form} layout="horizontal">
            <Form.Item
              name="poNumber"
              label={TLT(`PO单号`)}
              required
              rules={[{ required: true, message: TLT(`请输入PO单号`)}]}
              className="po-form-item"
            >
              <Input 
                placeholder={TLT(`请输入PO单号`)} 
                value={poNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  setPoNumber(value);
                  // 更新表单字段值
                  form.setFieldsValue({ poNumber: value });
                }}
                className="po-input"
              />
            </Form.Item>
          </Form>
        </div>
        
        <div className="po-popup-footer">
          <Space>
            <Button onClick={onCancel}>{TLT(`取消`)}</Button>
            <Button 
              type="primary" 
              onClick={handleConfirm} 
              loading={submitLoading}
            >
              {TLT(`确定`)}
            </Button>
          </Space>
        </div>
      </div>
    </Modal>
  );
};

export default PoPopup; 